
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitopunedailycab() {



    const cardData =
    {
        keyword: 'Mumbai to Pune Daily Cab',
        heading: 'Skyline Cabs: Mumbai to Pune Daily Cab ',
        headingDescription: 'Skyline Cabs offers convenient and affordable Mumbai to Pune Daily Cab services for those who travel regularly between the two cities. Whether it is for work, business meetings, or personal commitments, our reliable drivers and well-maintained vehicles ensure a comfortable and timely ride every day. With flexible scheduling, door-to-door service, and competitive fares, Skyline Cabs is your trusted partner for daily commutes from Mumbai to Pune. Book your daily cab with us and enjoy a smooth and stress-free journey every time.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Mumbai to Bhosari Cab Service",
      "description": "Skyline Cabs offers efficient cab services from Mumbai to Bhosari, Pune. Ideal for business visits or personal travel, our fleet includes comfortable sedans, Ertigas, and Innovas for a smooth and timely journey."
    },
    {
      "name": "Mumbai to Camp Pune Cab",
      "description": "Book a reliable cab from Mumbai to Pune Camp area with Skyline Cabs. Get safe, air-conditioned vehicles and experienced drivers for a comfortable ride to Pune's bustling commercial center."
    },
    {
      "name": "Mumbai to Sinhagad Road Cab",
      "description": "Travel conveniently from Mumbai to Sinhagad Road, Pune with Skyline Cabs. Our outstation service ensures door-to-door pickup, transparent fares, and a fleet of clean, well-maintained vehicles."
    },
    {
      "name": "Mumbai to Hinjewadi Taxi Fare",
      "description": "Get affordable and fixed taxi fares from Mumbai to Hinjewadi, Pune’s IT hub. Skyline Cabs offers comfortable travel options with trained drivers and no hidden charges, perfect for professionals and visitors."
    },
    {
      "name": "Mumbai to Wakad Cab",
      "description": "Need a cab from Mumbai to Wakad? Skyline Cabs offers reliable and budget-friendly options for solo travelers, families, and business professionals with round-the-clock service and GPS-enabled cars."
    },
    {
      "name": "Mumbai to Aundh Daily Cab Fare",
      "description": "Skyline Cabs provides daily cab services from Mumbai to Aundh with consistent pricing. Choose from sedan, Ertiga, or Innova for a personalized travel experience with punctual pickups."
    },
    {
      "name": "Mumbai to Koregaon Park Daily Cab Fare",
      "description": "Book a daily cab from Mumbai to Koregaon Park, Pune’s lifestyle hub. Skyline Cabs ensures smooth and stylish travel with flexible timings and premium vehicle options."
    },
    {
      "name": "Mumbai to Pune Daily Innova Fare",
      "description": "Travel daily from Mumbai to Pune in an Innova Crysta with Skyline Cabs. Enjoy luxury, comfort, and reliability at consistent rates ideal for regular commuters and frequent travelers."
    },
    {
      "name": "Mumbai to Pune Daily Ertiga Fare",
      "description": "Skyline Cabs offers affordable daily Ertiga services between Mumbai and Pune. Perfect for small groups and families seeking budget-friendly travel with comfortable seating and AC vehicles."
    },
    {
      "name": "Mumbai to Pune Daily Sedan Cab Fare",
      "description": "Book a daily sedan cab from Mumbai to Pune with Skyline Cabs. Our competitive fares make commuting economical and stress-free. Choose from Swift Dzire, Etios, and more."
    },
    {
      "name": "Mumbai Pune Daily Cab Service",
      "description": "Skyline Cabs operates a daily cab service between Mumbai and Pune. Get timely pickups, professional drivers, and multiple cab types for regular and comfortable intercity travel."
    },
    {
      "name": "Mumbai to Pimpri Daily Cab",
      "description": "Travel daily from Mumbai to Pimpri with Skyline Cabs. Our dependable service includes one-way and round-trip options, all at transparent pricing and with top-rated drivers."
    },
    {
      "name": "Cheapest Cab Mumbai to Pune",
      "description": "Looking for the most affordable cab from Mumbai to Pune? Skyline Cabs provides pocket-friendly fares with reliable service, clean vehicles, and professional chauffeurs ensuring a comfortable ride."
    },
    {
      "name": "Mumbai Airport to Pune Daily Cab Service",
      "description": "Skyline Cabs offers daily transfers from Mumbai Airport to Pune with on-time pickups, fixed pricing, and comfortable vehicles suitable for both domestic and international travelers."
    },
    {
      "name": "Mumbai Airport to Viman Nagar Cab Service",
      "description": "Get fast and reliable cab service from Mumbai Airport to Viman Nagar, Pune. Skyline Cabs offers 24/7 support, luxury cabs, and trained drivers for a hassle-free airport transfer."
    },
    {
      "name": "Mumbai Airport to Pune Taxi Fare",
      "description": "Enjoy affordable and all-inclusive taxi fare from Mumbai Airport to Pune with Skyline Cabs. Our prices cover tolls, driver charges, and taxes with no hidden fees."
    },
    {
      "name": "Top Rated Cab Service in Mumbai",
      "description": "Skyline Cabs is among the top-rated cab services in Mumbai. We specialize in outstation travel, including daily rides to Pune, airport transfers, and local rentals with the highest customer satisfaction."
    },
    {
      "name": "Best Outstation Cab Service in Mumbai",
      "description": "Planning an outstation trip? Skyline Cabs offers Mumbai’s best cab service for long-distance travel. With competitive pricing, modern vehicles, and courteous drivers, your journey is in safe hands."
    }
  ],
  "tableData": [
    ["Mumbai to Bhosari Cab Service", "Mumbai to Camp Pune Cab"],
    ["Mumbai to Sinhagad Road Cab", "Mumbai to Hinjewadi Taxi Fare"],
    ["Mumbai to Wakad Cab", "Mumbai to Aundh Daily Cab Fare"],
    ["Mumbai to Koregaon Park Daily Cab Fare", "Mumbai to Pune Daily Innova Fare"],
    ["Mumbai to Pune Daily Ertiga Fare", "Mumbai to Pune Daily Sedan Cab Fare"],
    ["Mumbai Pune Daily Cab Service", "Mumbai to Pimpri Daily Cab"],
    ["Cheapest Cab Mumbai to Pune", "Mumbai Airport to Pune Daily Cab Service"],
    ["Mumbai Airport to Viman Nagar Cab Service", "Mumbai Airport to Pune Taxi Fare"],
    ["Top Rated Cab Service in Mumbai", "Best Outstation Cab Service in Mumbai"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai to Pune Daily Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers dependable daily cab services between Mumbai and Pune, perfect for regular commuters, business travelers, and anyone who needs consistent and punctual transportation. Our service ensures a seamless experience every day, without delays or cancellations."
    },
    {
        "WhyChooseheading": "Comfortable Rides for Your Daily Travel",
        "WhyChoosedescription": "Travel in comfort with our clean, air-conditioned cabs that are perfect for long daily journeys. Whether you're commuting for work or frequent visits, our sedans and SUVs provide a relaxing and spacious ride from Mumbai to Pune, even during peak hours."
    },
    {
        "WhyChooseheading": "Professional and Punctual Drivers",
        "WhyChoosedescription": "Our drivers are trained professionals who value your time. They are punctual, courteous, and know the best routes to ensure a smooth and timely commute from Mumbai to Pune every single day. With Skyline Cabs, you’re always in safe and experienced hands."
    },
    {
        "WhyChooseheading": "Cost-Effective Daily Travel Plans",
        "WhyChoosedescription": "Enjoy affordable daily cab services with flexible plans. Whether you prefer daily bookings or want to pre-schedule your rides for the week, Skyline Cabs offers budget-friendly pricing with no hidden charges—ideal for frequent Mumbai to Pune travelers."
    },
    {
        "WhyChooseheading": "24/7 Service for Any Time Travel",
        "WhyChoosedescription": "Skyline Cabs operates round the clock, making it easy for daily commuters with early starts or late returns. Our 24/7 availability ensures you have reliable transport no matter what your schedule looks like—day or night."
    },
    {
        "WhyChooseheading": "Cab Options to Match Your Lifestyle",
        "WhyChoosedescription": "Whether you need an economical sedan for solo travel or a spacious SUV for added comfort, our wide range of vehicles is perfect for daily trips. We cater to professionals, students, and business executives with flexible options to suit all needs."
    },
    {
        "WhyChooseheading": "Fast Booking and Repeat Scheduling",
        "WhyChoosedescription": "Booking your daily Mumbai to Pune cab is easy with our app or website. Set up recurring rides, save your preferences, and get reminders and instant confirmations—making daily travel effortless and stress-free."
    },
    {
        "WhyChooseheading": "Safe, Sanitized, and GPS-Enabled Cabs",
        "WhyChoosedescription": "Your safety is our priority. All Skyline Cabs are thoroughly sanitized, GPS-tracked, and driven by background-verified drivers. For daily Mumbai to Pune commuters, this means peace of mind with every ride—reliable, clean, and secure transport every time."
    }
]























    }


    const faqData = [
        {
            id: 1,
            question: 'Does Skyline Cabs offer daily cab service from Mumbai to Pune?',
            answer:
                'Yes, we provide daily cab services between Mumbai and Pune. Whether it’s for work, business, or personal reasons, you can book a comfortable daily ride with us.',
        },
        {
            id: 2,
            question: 'Can I book a fixed-time daily cab from Mumbai to Pune?',
            answer:
                'Absolutely. You can schedule a cab at the same time every day and we’ll ensure a car and driver are assigned to you consistently for your daily travel.',
        },
        {
            id: 3,
            question: 'Is the Mumbai to Pune daily cab available on weekends?',
            answer:
                'Yes, our daily cab services operate 7 days a week — including weekends and public holidays. You can rely on us anytime you need a ride.',
        },
        {
            id: 4,
            question: 'Do you offer shared daily cabs or only private ones?',
            answer:
                'We primarily offer private cabs for a more personalized experience. Shared rides may be available on select routes and times. Contact us to check availability.',
        },
        {
            id: 5,
            question: 'What is the travel time from Mumbai to Pune in daily cabs?',
            answer:
                'The usual travel time is around 3.5 to 5 hours, depending on traffic. Our experienced drivers follow the safest and fastest routes to ensure timely arrival.',
        },
        {
            id: 6,
            question: 'What kind of cars are used for daily travel?',
            answer:
                'We use well-maintained Sedans, SUVs, and MUVs like Ertiga and Innova for daily trips. You can choose a car type based on your comfort and needs.',
        },
        {
            id: 7,
            question: 'Is there a monthly subscription or package for daily cabs?',
            answer:
                'Yes, we offer discounted packages for regular travelers. You can opt for weekly or monthly plans based on your schedule. Contact our support for more details.',
        },
        {
            id: 8,
            question: 'Can I modify or cancel my daily cab schedule?',
            answer:
                'Yes, you can modify or cancel your ride easily via our app, website, or by calling customer support. We offer flexible booking management for daily commuters.',
        },
        {
            id: 9,
            question: 'Is the fare fixed for daily Mumbai to Pune travel?',
            answer:
                'Yes, our fares are fixed and transparent. If you opt for a subscription or regular plan, you also get additional discounts.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for daily Mumbai to Pune travel?',
            answer:
                'Skyline Cabs ensures timely pickups, experienced drivers, clean vehicles, and fixed fares — making your daily commute hassle-free and comfortable.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Nikhil Thakur",
            rating: 5,
            review: "I use Skyline Cabs almost every day to travel from Mumbai to Pune for work. The service is consistent, drivers are punctual, and I always arrive on time. Truly dependable for daily commuting!"
        },
        {
            name: "Miss. Priya Nair",
            rating: 4,
            review: "Started using Skyline for my weekend Pune trips from Mumbai. The ride is super smooth, and the drivers are friendly. It’s made my routine travel a lot more stress-free!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Daily Cabs",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-pune-daily-cab.jpg",
  "description": "Book Mumbai to Pune daily cabs with Skyline Cabs for consistent, safe, and timely service. Ideal for regular commuters, business travelers, and students—choose from AC sedans and SUVs with verified drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8123"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1250",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-pune-daily-cabs"
  }
};



      
     
      


    return (
        <div>

<Helmet>
  <title>Mumbai to Pune Daily Cabs | Safe & Timely Commute | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pune daily cabs with Skyline Cabs for consistent, safe, and timely service. Ideal for regular commuters, business travelers, and students—choose from AC sedans and SUVs with verified drivers." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pune Daily Cabs, Daily Cab Service Mumbai to Pune, Regular Taxi Mumbai Pune, Office Cab Mumbai to Pune, AC Daily Cabs Mumbai Pune, SUV Daily Taxi Mumbai Pune, Business Travel Cab Mumbai to Pune, Skyline Cabs Daily Route, Daily Pune Mumbai Car Hire, Verified Drivers Mumbai to Pune Daily" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/40.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopunedailycab;